import React from "react";
import styles from "./SimpleFeatureList.module.scss";
import DynamicFontAwesomeIcon from "components/elements/DynamicFontAwesomeIcon";

const SimpleFeatureList = (props) => {
    const { list, data, vertical = false } = props;
    
    let listToRender = data?.[0]?.simple_feature_list || data?.[0]?.list || list;
    
    return (
        <div className={`${styles.SimpleFeatureList} ${vertical ? 'vertical' : 'horizontal'}`}>
            {listToRender?.title && (
                <div className="d-flex align-items-center mb-3">
                    <h4 className="feature-title contrast mb-0">{listToRender.title}</h4>
                </div>
            )}
            
            <div className="feature-list">
                <div className={`${vertical ? 'd-flex flex-column' : 'row'}`}>
                    {listToRender?.items && listToRender.items.map((item, index) => (
                        item.value && (
                            <div key={index} className={`feature-item ${vertical ? 'mb-3' : 'col'}`}>
                                <div className="d-flex align-items-center">
                                {item.icon && <div className="feature-icon contrast">
                                         <DynamicFontAwesomeIcon iconName={item.icon} size="lg" className="me-2" />
                                    </div>}
                                    <div className="feature-content">
                                        {item.link ? (
                                            <a 
                                                href={item.link} 
                                                target="_blank" 
                                                rel="noopener noreferrer" 
                                                className="contrast"
                                            >
                                                <span dangerouslySetInnerHTML={{ __html: item.value }}></span>
                                            </a>
                                        ) : (
                                            <span className="contrast" dangerouslySetInnerHTML={{ __html: item.value }}></span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SimpleFeatureList;
